export const CommonMessages = {
  expiredLink: "Your link has expired, click here to resend.",
};
